import React from 'react';
import { Dimmer, Grid, Loader, Segment } from 'semantic-ui-react';

export default function Loading() {
    return (
        <Grid centered columns={2} className='denied-page' style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '100vh'}}>
            <Segment className='loader-container'  basic>
                <Dimmer active inverted>
                    <Loader className='loading-page'inverted> Loading </Loader>
                </Dimmer>
            </Segment>
        </Grid>
    )
}